<template>
  <div class="Warehouse">
    <el-row>
      <el-col :span="10">
        <el-input v-model.trim="search" placeholder="仓库名称、仓库编号" style="width: 70%;"></el-input>
        <el-button style="margin: 0 10px;" type="primary" @click="searchData2">搜索</el-button>
        <el-button type="primary" @click="reset">重置</el-button>
      </el-col>
      <el-col :span="2" :offset="12">
        <el-button type="primary" @click="Addestablish">创建仓库</el-button>
      </el-col>
    </el-row>
    <el-divider></el-divider>
    <el-row :gutter="20">
      <el-col :span="3" :offset="21">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="currentPage"
          :page-sizes="[50, 100, 200, 400]"
          :page-size="pagesize"
          layout="total, sizes"
          :total="total"
        ></el-pagination>
      </el-col>
    </el-row>
    <div class="margin-top1">
      <el-table border :data="tableData" style="width: 100%">
        <el-table-column label="仓库名称" prop="warehouseName" align="center"></el-table-column>
        <el-table-column label="仓库编号" prop="id" align="center"></el-table-column>
        <el-table-column label="创建时间" prop="createTime" align="center"></el-table-column>
        <el-table-column label="更新时间" prop="updateTime" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="Setup(scope.row)">设置</el-button>
            <el-button type="danger" @click="Delete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="page">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[50, 100, 200, 400]"
      :page-size="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    </div>

    <el-dialog title="仓库创建" :visible.sync="establish" width="45%" append-to-body>
        <div class="margin-top1">
          <el-form>
            <el-form-item label="仓库名称" :label-width="formLabelWidth">
              <el-input v-model="warehouseName" class="width80"></el-input>
            </el-form-item>
            <el-form-item label="负责人" :label-width="formLabelWidth">
              <el-input v-model="principal" class="width80"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" :label-width="formLabelWidth">
              <el-input v-model="telephone" class="width80"></el-input>
            </el-form-item>
            <el-form-item label="email" :label-width="formLabelWidth">
              <el-input v-model="email" class="width80"></el-input>
            </el-form-item>
            <el-form-item label="中文地址" :label-width="formLabelWidth">
              <el-input
                v-model="chineseAddress"
                type="textarea"
                class="width80"
              ></el-input>
            </el-form-item>
            <el-form-item label="英文地址" :label-width="formLabelWidth">
              <el-input
                v-model="englishAddress"
                type="textarea"
                class="width80"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" :label-width="formLabelWidth">
              <el-input
                v-model="remarks"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                class="width80"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="establish = false">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="仓库设置" :visible.sync="establish1" width="45%" append-to-body>
      <div class="dialog_formt">
        <p>基本设置</p>
        <div class="margin-top1">
          <el-form>
            <el-form-item label="仓库名称" :label-width="formLabelWidth">
              <el-input v-model="warehouseName1" class="width80"></el-input>
            </el-form-item>
            <el-form-item label="负责人" :label-width="formLabelWidth">
              <el-input v-model="principal1" class="width80"></el-input>
            </el-form-item>
            <el-form-item label="联系电话" :label-width="formLabelWidth">
              <el-input v-model="telephone1" class="width80"></el-input>
            </el-form-item>
            <el-form-item label="email" :label-width="formLabelWidth">
              <el-input v-model="email1" class="width80"></el-input>
            </el-form-item>
            <el-form-item label="中文地址" :label-width="formLabelWidth">
              <el-input
                v-model="chineseAddress1"
                type="textarea"
                class="width80"
              ></el-input>
            </el-form-item>
            <el-form-item label="英文地址" :label-width="formLabelWidth">
              <el-input
                v-model="englishAddress1"
                type="textarea"
                class="width80"
              ></el-input>
            </el-form-item>
            <el-form-item label="备注" :label-width="formLabelWidth">
              <el-input
                v-model="remarks1"
                type="textarea"
                :autosize="{ minRows: 2, maxRows: 4}"
                class="width80"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      
      <div class="goods_shelves margin-top1">
        <div class="goods_shelvestop">
          <span>货架设置</span>
          <div style="margin-right:10px;">
          <el-button type="primary" size="mini" @click="innerVisible = true">新增货架</el-button>
          <el-button type="primary" size="mini" @click="innerVisible1 = true">批量新增货架</el-button>
          </div>
        </div>
        <div class="form_ul_li margin-top1">
            <el-table :data="tableShelves" border style="width: 100%">
              <el-table-column prop="shelfNumber" label="货架编号" width="180" align="center"></el-table-column>
              <el-table-column label="货架类型" width="180" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.shelfType === 1">退回</span>
                  <span v-if="scope.row.shelfType === 2">未知</span>
                  <span v-if="scope.row.shelfType === 3">异常</span>
                  <span v-if="scope.row.shelfType === 4">库存</span>
                  <span v-if="scope.row.shelfType === 5">暂存</span>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" align="center"></el-table-column>
              <el-table-column prop="updateTime" label="更新时间" align="center"></el-table-column>
              <el-table-column  label="操作" align="center">
                <template slot-scope="scope">
                  <el-button type="primary" @click="EditShelves(scope.row)">编辑</el-button>
                  <el-button type="danger" @click="DeleteShelves(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="pagestyle">
            <el-pagination
              @size-change="handleSizeChange1"
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-sizes="[3, 5, 10, 20]"
              :page-size="pagesize1"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total1"
          ></el-pagination>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="establish1 = false">取 消</el-button>
        <el-button type="primary" @click="SetupSave">确 定</el-button>
      </div>

      <el-dialog width="30%" title="货架设置" :visible.sync="innerVisible" append-to-body>
        <div>
          <el-form>
            <el-form-item label-width="10px">
              <el-input placeholder="请输入内容" v-model="ShelvesNumber">
                  <template slot="prepend">货架编号</template>
                </el-input>
            </el-form-item>
            <el-form-item label="货架类型" label-width="80px">
              <el-radio-group v-model="radio">
                <el-radio label="1">退回</el-radio>
                <el-radio label="2">未知</el-radio>
                <el-radio label="3">异常</el-radio>
                <el-radio label="4">库存</el-radio>
                <el-radio label="5">暂存</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel">取 消</el-button>
          <el-button type="primary" @click="AddShelves">确 定</el-button>
        </div>
      </el-dialog>


      <el-dialog width="30%" title="批量货架设置" :visible.sync="innerVisible1" append-to-body>
        <div>
          <el-form label-width="20px">
            <el-row>
            <el-col :span="12">
              <el-form-item>
                <el-input placeholder="请输入内容" v-model="prefix">
                  <template slot="prepend">前缀</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
            <el-form-item>
              <el-input placeholder="请输入内容" v-model="suffix">
                  <template slot="prepend">后缀</template>
                </el-input>
            </el-form-item>
            </el-col>
            </el-row>

            <el-row>
            <el-col :span="12">
              <el-form-item>
                <el-input placeholder="请输入内容" v-model="startingNumber">
                  <template slot="prepend">起始数</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
            <el-form-item>
              <el-input placeholder="请输入内容" v-model="digits">
                  <template slot="prepend">位数</template>
                </el-input>
            </el-form-item>
            </el-col>
            </el-row>

            <el-row>
            <el-col :span="12">
            <el-form-item>
              <el-input placeholder="请输入内容" v-model="quantity">
                  <template slot="prepend">数量</template>
                </el-input>
            </el-form-item>
            </el-col>
            </el-row>
            <el-form-item label="货架类型" label-width="80px">
              <el-radio-group v-model="radio">
                <el-radio label="1">退回</el-radio>
                <el-radio label="2">未知</el-radio>
                <el-radio label="3">异常</el-radio>
                <el-radio label="4">库存</el-radio>
                <el-radio label="5">暂存</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="cancel1">取 消</el-button>
          <el-button type="primary" @click="AddShelves1">确 定</el-button>
        </div>
      </el-dialog>

      <el-dialog width="30%" title="货架编辑" :visible.sync="innerVisible2" append-to-body>
        <div>
          <el-form>
            <el-form-item label-width="10px">
              <el-input placeholder="请输入内容" v-model="ShelvesNumber1">
                  <template slot="prepend">货架编号</template>
                </el-input>
            </el-form-item>
            <el-form-item label="货架类型" label-width="80px">
              <el-radio-group v-model="radio1">
                <el-radio :label="1">退回</el-radio>
                <el-radio :label="2">未知</el-radio>
                <el-radio :label="3">异常</el-radio>
                <el-radio :label="4">库存</el-radio>
                <el-radio :label="5">暂存</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="innerVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="EditShelvesSave">确 定</el-button>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from "../../api/api/api";
export default {
  name: "Warehouse",
  data() {
    return {
      tableData: [],
      tableShelves:[],
      establish: false,
      establish1: false,
      innerVisible:false,
      innerVisible1:false,
      innerVisible2:false,
      formLabelWidth: "100px",

      warehouseName:"",
      principal:"",
      telephone:"",
      email:"",
      chineseAddress:"",
      englishAddress:"",
      remarks:"",

      warehouseName1:"",
      principal1:"",
      telephone1:"",
      email1:"",
      chineseAddress1:"",
      englishAddress1:"",
      remarks1:"",
      
      currentPage: 1,
      pagesize: 50,
      size: 50,
      total: 0,

      currentPage1: 1,
      pagesize1: 3,
      size1: 3,
      total1: 0,

      warehouseid:"",
      radio:"",
      ShelvesNumber:"",
      radio1:"",
      ShelvesNumber1:"",
      shelvesid:"",
      quantity:"",
      digits:"",
      startingNumber:"",
      suffix:"",
      prefix:"",

      search: ""
    };
  },
  mounted() {},
  created() {
    this.tableList()
  },
  methods: {
    //仓库列表
    tableList(){
      var obj = {
        page:this.currentPage,
        size:this.size
      }
      ajaxPost(Baseurl + "warehouseController/selectWarehouseInfo", obj).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
      });
    },
    //添加仓库
    Addestablish() {
      this.establish = true;
    },
    //提交添加的仓库
    save(){
      var obj = {
        warehouseName:this.warehouseName,
        principal:this.principal,
        telephone:this.telephone,
        email:this.email,
        chineseAddress:this.chineseAddress,
        englishAddress:this.englishAddress,
        remarks:this.remarks
      }
      ajaxPost(Baseurl + "warehouseController/insertWarehouseInfo", obj).then(res => {
          // console.log(res.data)
          if(res.data.code == 200){
            this.$message({
              message: '添加仓库成功',
              type: 'success'
            });
            this.tableList()
          }else{
            this.$message.error(res.data.data);
          }
          this.warehouseName = ""
          this.principal = ""
          this.telephone = ""
          this.email = ""
          this.chineseAddress = ""
          this.englishAddress = ""
          this.remarks = ""
          this.establish = false
      });
    },
    //编辑仓库
    Setup(item) {
      this.warehouseid = item.id
      this.establish1 = true;
      this.warehouseName1 = item.warehouseName
      this.principal1 = item.principal
      this.telephone1 = item.telephone
      this.email1 = item.telephone
      this.chineseAddress1 = item.chineseAddress
      this.englishAddress1 = item.englishAddress
      this.remarks1 = item.remarks

      this.shelvesList()
    },
    //货架列表
    shelvesList(){
      var obj = {
        warehouseId:this.warehouseid,
        page:this.currentPage1,
        size:this.size1
      }
      ajaxPost(Baseurl + "shelfController/selectShelfInfo", obj).then(res => {
        console.log(res.data)
        this.tableShelves = res.data.data.list
        this.total1 = res.data.data.total
      });
    },
    //编辑仓库
    SetupSave(){
      this.establish1 = false
      var obj = {
        id:this.warehouseid,
        warehouseName:this.warehouseName1,
        principal:this.principal1,
        telephone:this.telephone1,
        email:this.email1,
        chineseAddress:this.chineseAddress1,
        englishAddress:this.englishAddress1,
        remarks:this.remarks1
      }
      ajaxPost(Baseurl + "warehouseController/updateWarehouseInfo", obj).then(res => {
        console.log(res.data)
          if(res.data.code == 200){
            this.$message({
              message: '编辑仓库成功',
              type: 'success'
            });
            this.tableList()
          }else{
            this.$message.error('编辑仓库失败');
          }
      });
    },
    //删除仓库
    Delete(item){
      this.$confirm('是否删除仓库?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var obj = {
            id:item.id
          }
          ajaxPost(Baseurl + "warehouseController/deleteWarehouseInfo", obj).then(res => {
            if(res.data.code == 200){
              this.$message({
                message: '删除仓库成功',
                type: 'success'
              });
              this.tableList()
            }else{
              this.$message.error('删除仓库失败');
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    //添加货架
    AddShelves(){
      if(this.radio === ""){
        this.$message.error("请选择货架类型");
      }else if(this.warehouseid === ""){
        this.$message.error("请输入货架编号");
      }else{
        var obj = {
          shelfNumber:this.ShelvesNumber,
          shelfType:this.radio,
          warehouseId:this.warehouseid
        }
        ajaxPost(Baseurl + "shelfController/insertShelfInfo", obj).then(res => {
            if(res.data.code == 200){
              this.$message({
                  message: '添加货架成功',
                  type: 'success'
              });
              this.shelvesList()
            }else{
              this.$message.error(res.data.data);
            }
            this.innerVisible = false
            this.ShelvesNumber = ""
            this.radio = ""
        });
      }
    },
    //取消添加货架
    cancel(){
      this.innerVisible = false
      this.ShelvesNumber = ""
      this.radio = ""
    },
    //批量添加货架
    AddShelves1(){
      if(this.radio === ""){
        this.$message.error("请选择货架类型");
      }else if(this.prefix === ""){
        this.$message.error("请输入前缀");
      }else if(this.suffix === ""){
        this.$message.error("请输入后缀");
      }else if(this.startingNumber === ""){
        this.$message.error("请输入起始数");
      }else if(this.digits === ""){
        this.$message.error("请输入位数");
      }else if(this.quantity === ""){
        this.$message.error("请输入数量");
      }else{
        var obj = {
          shelfType:this.radio,
          warehouseId:this.warehouseid,
          quantity:this.quantity,
          digits:this.digits,
          startingNumber:this.startingNumber,
          suffix:this.suffix,
          prefix:this.prefix,
          shelfNumber:""
        }
        ajaxPost(Baseurl + "shelfController/insertShelfInfo", obj).then(res => {
            if(res.data.code == 200){
              this.$message({
                  message: '批量添加货架成功',
                  type: 'success'
              });
              this.shelvesList()
            }else{
              this.$message.error(res.data.data);
            }
            this.innerVisible1 = false
            this.quantity = "",
            this.digits = "",
            this.startingNumber = "",
            this.suffix = "",
            this.prefix = "",
            this.radio = ""
        });
      }

    },
    //取消批量添加货架
    cancel1(){
      this.innerVisible1 = false
      this.quantity = "",
      this.digits = "",
      this.startingNumber = "",
      this.suffix = "",
      this.prefix = "",
      this.radio = ""
    },
    //删除货架
    DeleteShelves(val){
       this.$confirm('确定删除此货架?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        var obj = {
          id:val.id
        }
        ajaxPost(Baseurl + "shelfController/deleteShelfInfo", obj).then(res => {
            if(res.data.code == 200){
              this.$message({
                  message: '删除货架成功',
                  type: 'success'
              });
              this.shelvesList()
            }else{
              this.$message.error("删除货架失败");
            }
        });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
    },
    //编辑当前货架
    EditShelves(val){
      this.innerVisible2 = true
      this.shelvesid = val.id
      this.radio1 = val.shelfType
      this.ShelvesNumber1 = val.shelfNumber
    },
    //提交编辑当前货架
    EditShelvesSave(){
      var obj = {
        id:this.shelvesid,
        shelfNumber:this.ShelvesNumber1,
        shelfType:this.radio1,
        warehouseId:this.warehouseid
      }
      console.log(obj)
      ajaxPost(Baseurl + "shelfController/updateShelfInfo", obj).then(res => {
          if(res.data.code == 200){
              this.$message({
                  message: '编辑货架成功',
                  type: 'success'
              });
              this.shelvesList()
          }else{
              this.$message.error("编辑货架失败");
          }
          this.innerVisible2 = false
      });
    },
    //仓库列表分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.size = val;
      var obj = {
        page:this.currentPage,
        size:this.size
      }
      ajaxPost(Baseurl + "warehouseController/selectWarehouseInfo", obj).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total;
      });
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      var obj = {
        page:this.currentPage,
        size:this.size
      }
      ajaxPost(Baseurl + "warehouseController/selectWarehouseInfo", obj).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total;
      });
    },
    //货架列表分页
    handleSizeChange1(val) {
      console.log(`每页 ${val} 条`);
      this.size1 = val;
      var obj = {
        warehouseId:this.warehouseid,
        page:this.currentPage1,
        size:this.size1
      }
      ajaxPost(Baseurl + "shelfController/selectShelfInfo", obj).then(res => {
          this.tableShelves = res.data.data.list
          this.total1 = res.data.data.total
      });
    },
    handleCurrentChange1(val) {
      console.log(`当前页: ${val}`);
      this.currentPage1 = val;
      var obj = {
        warehouseId:this.warehouseid,
        page:this.currentPage1,
        size:this.size1
      }
      ajaxPost(Baseurl + "shelfController/selectShelfInfo", obj).then(res => {
          this.tableShelves = res.data.data.list
          this.total1 = res.data.data.total
      });
    },
    searchData2(){
      this.currentPage = 1
      this.searchData()
    },
    //搜素
    searchData(){
      var obj = {
        page:this.currentPage,
        size:this.size,
        searchStr:this.search
      }
      ajaxPost(Baseurl + "warehouseController/selectWarehouseInfoByCondition", obj).then(res => {
          this.tableData = res.data.data.list
          this.total = res.data.data.total;
      });
    },
    //重置
    reset(){
      this.search = ""
      this.currentPage = 1
      this.tableList()
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/ {
  .width80 {
    width: 80%;
  }
}
.Warehouse {
  width: 98%;
  overflow: hidden;
}
.pagestyle{
  height: 40px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog_formt {
  border: #d6e9c6 1px solid;
  border-radius: 5px;
  p {
    color: #3c763d;
    background-color: #dff0d8;
    border-color: #d6e9c6;
    line-height: 40px;
    font-size: 16px;
    padding: 0 10px;
  }
}
  .page {
    position: fixed;
    width: 80%;
    bottom: 0;
    background-color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 50px;
  }
.goods_shelves {
  border: #bce8f1 1px solid;
  border-radius: 5px;
  .goods_shelvestop {
    display: flex;
    justify-content: space-between;
    align-items: center;
    overflow: hidden;
    color: #31708f;
    background-color: #d9edf7;
    border-color: #bce8f1;
    span {
      line-height: 40px;
      padding: 0 10px;
      font-size: 16px;
    }
  }
  .form-inline {
    overflow: hidden;
    padding: 6px 10px;
    border-bottom: 1px dotted darkturquoise;
  }
  .multi-shelf-before {
    width: 70px;
    border-radius: 2px;
    border: 1px solid wheat;
  }
  .form_ul_li {
    overflow: hidden;
    li {
      height: 150px;
      width: 150px;
      float: left;
      margin-right: 10px;
      margin-bottom: 20px;
      border: 1px solid dodgerblue;
      .lihead {
        height: 40px;
        border-bottom: 1px dotted dodgerblue;
        line-height: 40px;
        span {
          display: block;
          text-align: center;
          font-weight: 600;
        }
      }
      .limiddle {
        padding: 10px;
        border-bottom: 1px dotted dodgerblue;
        .el-radio {
          margin-right: 5px;
        }
        p {
          line-height: 58px;
          text-align: center;
        }
      }
      .libottom {
        text-align: center;
        line-height: 30px;
        font-size: 13px;
        color: #337ab7;
      }
    }
    .addli {
      height: 150px;
      width: 150px;
      border: 1px dashed dodgerblue;
      float: left;
      margin-right: 10px;
      text-align: center;
      font-size: 25px;
      color: dodgerblue;
      cursor: pointer;
      line-height: 150px;
      transition: all 0.3s ease;
      margin-bottom: 20px;
    }
  }
  
}
</style>